module.exports = __webpack_public_path__ + "img/payment_success.3220963.svg";